export const SettingsCard = ({ icon: Icon, title, description, children, testid }) => (
  <div className="rounded-2xl border border-[#E7E2DA] bg-white p-5 sm:p-6 mt-5" data-testid={testid}>
    <div className="flex items-center gap-2 mb-1">
      <span className="h-9 w-9 rounded-xl bg-[#F1EBE1] flex items-center justify-center">
        <Icon className="h-4.5 w-4.5 text-[#1A1A1A]" />
      </span>
      <h2 className="text-lg font-medium text-[#1A1A1A]">{title}</h2>
    </div>
    <p className="text-sm text-[#8A7E70] mb-5 ml-11">{description}</p>
    {children}
  </div>
);

export const SaveButton = ({ pending, onClick, testid, disabled }) => (
  <button
    data-testid={testid}
    onClick={onClick}
    disabled={pending || disabled}
    className="inline-flex items-center h-11 px-6 rounded-md bg-[#1A1A1A] hover:bg-black text-white text-sm font-medium transition-colors disabled:opacity-60"
  >
    {pending ? "Guardando…" : "Guardar cambios"}
  </button>
);
